<main *ngIf="data">
  <div class="datebox">
    <h2 class="sub-title sub-title-first">基金資產</h2>
    <div class="date">資料日期：{{data.Date}}</div>
  </div>
  <div class="item-asset">
    <div class="item-title">基金淨資產價值</div>
    <div>{{ addThousandsSeparator(data.Item1[0].Fund_Size) }}</div>
  </div>
  <div class="item-asset">
    <div class="item-title">基金在外流通單位數</div>
    <div>{{ addThousandsSeparator(data.Item1[0].Fund_Unit) }} </div>
  </div>
  <div class="item-asset">
    <div class="item-title">基金每單位淨值</div>
    <div>{{ addThousandsSeparator(data.Item1[0].Fund_NAV) }}</div>
  </div>

  <!-- item2 start -->
  <table class="table-web item1-table">
    <thead>
      <tr>
        <th>項目</th>
        <th>金額</th>
        <th>權重</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of data.Item2 | slice:0:shownCountItem2">
        <tr>
          <th>{{item.Item}}</th>
          <td>{{item.Amt}}</td>
          <td>{{item.Rate}}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- 顯示更多按鈕 -->
  <button *ngIf="!isMobile && data.Item2.length > shownCountItem2" class="arrow-btn" style="margin-top: 25px;" (click)="showMoreItem2()">
    顯示更多 <div class="top-arrow"></div>
  </button>
  <!-- 無更多資料 -->
  <p class="no-data" *ngIf="!isMobile && data.Item2.length > 10 && data.Item2.length <= shownCountItem2">
    無更多資料
  </p>

  <!-- mobile -->
 <ng-container *ngFor="let item of data.Item2 | slice:0:shownCountItem2">
    <table class="table-mob">
      <thead>
        <tr>
          <th>項目
            <span class="code">{{item.Item}}</span>
          </th>
          <th>金額
            <span>{{item.Amt}}</span>
          </th>
          <th>權重
            <span>{{item.Rate}}</span>
          </th>
        </tr>
      </thead>
    </table>
  </ng-container>
  <div style="margin: 5px 0 16px 0; text-align: center;">
    <!-- 顯示更多按鈕 -->
    <button
      *ngIf="isMobile && data.Item2.length > shownCountItem2" class="arrow-btn" (click)="showMoreItem2()">
      顯示更多 <div class="top-arrow"></div>
    </button>
    <!-- 無更多資料 -->
    <p class="no-data" *ngIf="isMobile && data.Item2.length > 10 && data.Item2.length <= shownCountItem2">
      無更多資料
    </p>
  </div>
  <!-- item2 end -->

  <!-- item3 start -->
  <table class="table-web item2-table">
    <thead>
      <tr>
        <th>項目</th>
        <th>金額</th>
        <th>權重</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of data.Item3 | slice:0:shownCountItem3">
        <tr>
          <th>{{item.Item}}</th>
          <td>{{item.Amt}}</td>
          <td>{{item.Rate}}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- 顯示更多按鈕 -->
  <button *ngIf="!isMobile && data.Item3.length > shownCountItem3" class="arrow-btn" style="margin-top: 25px;" (click)="showMoreItem3()">
    顯示更多 <div class="top-arrow"></div>
  </button>
  <!-- 無更多資料 -->
  <p class="no-data" *ngIf="!isMobile && data.Item3.length > 10 && data.Item3.length <= shownCountItem3">
    無更多資料
  </p>

  <!-- mobile -->
  <ng-container *ngFor="let item of data.Item3 | slice:0:shownCountItem3">
    <table class="table-mob">
      <thead>
        <tr>
          <th>項目
            <span class="code">{{item.Item}}</span>
          </th>
          <th>金額
            <span>{{item.Amt}}</span>
          </th>
          <th>權重
            <span>{{item.Rate}}</span>
          </th>
        </tr>
      </thead>
    </table>
  </ng-container>
  <div style="margin: 5px 0 16px 0; text-align: center;">
    <!-- 顯示更多按鈕 -->
    <button
      *ngIf="isMobile && data.Item3.length > shownCountItem3" class="arrow-btn" (click)="showMoreItem3()">
      顯示更多 <div class="top-arrow"></div>
    </button>
    <!-- 無更多資料 -->
    <p class="no-data" *ngIf="isMobile && data.Item3.length > 10 && data.Item3.length <= shownCountItem3">
      無更多資料
    </p>
  </div>
  <!-- item3 end -->

  <!-- 動態表格 start -->
  <ng-container *ngFor="let item of data.Tables; let i = index">
    <h2 class="sub-title item-web-table-title">{{item.TableTitle}}</h2>
    <table class="table-web table dynamic-tables">
      <thead>
        <tr>
          <!-- 動態生成表頭 -->
          <th *ngFor="let col of item.Columns" [style.width]="col.ColumnsRate">
            {{ col.ColumnsName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- 動態生成表格內容 -->
       <tr *ngFor="let row of item.RowDetails | slice:0:shownCounts[i]">
            <td *ngFor="let cell of row; let j = index" [style.width]="item.Columns[j]?.ColumnsRate">
            {{ cell }}
        </td>
        </tr>
      </tbody>
    </table>
      <!-- 顯示更多／無更多資料 -->
  <div style="margin-top: 25px; text-align: center;">
    <button *ngIf="!isMobile && item.RowDetails.length > shownCounts[i]" class="arrow-btn" (click)="showMoreTable(i)">
      顯示更多 <div class="top-arrow"></div>
    </button>
    <p class="no-data" *ngIf="!isMobile && item.RowDetails.length > 10 && item.RowDetails.length <= shownCounts[i]">
      無更多資料
    </p>
  </div>
    <div class="item-web-remark" [innerHTML]="item.Remark | html"></div>
  </ng-container>

  <!-- mobile -->
  <ng-container *ngFor="let item of data.Tables; let i = index">
  <h2 class="sub-title item-mob-table-title">{{item.TableTitle}}</h2>

  <!-- 顯示前 N 筆資料 -->
  <ng-container *ngFor="let row of item.RowDetails | slice:0:shownCounts[i]">
    <table class="table-mob-dynamic">
      <thead>
        <tr>
          <ng-container *ngFor="let col of item.Columns; let i = index">
            <th>{{col.ColumnsName}}
              <span class="code">{{row[i]}}</span>
            </th>
          </ng-container>
        </tr>
      </thead>
    </table>
  </ng-container>

  <!-- 顯示更多 / 無更多資料 -->
  <div style="text-align: center; margin: 12px 0 24px 0;">
    <button *ngIf="isMobile && item.RowDetails.length > shownCounts[i]" class="arrow-btn" (click)="showMoreTable(i)">
      顯示更多
      <div class="top-arrow"></div>
    </button>
    <p class="no-data" *ngIf="isMobile && item.RowDetails.length > 10 && item.RowDetails.length <= shownCounts[i]">
      無更多資料
    </p>
  </div>

  <div class="item-mob-remark" [innerHTML]="item.Remark | html"></div>
</ng-container>


  <!-- <ng-container *ngFor="let item of data.Tables">
    <h2 class="sub-title item-mob-table-title">{{item.TableTitle}}</h2>

    <ng-container *ngFor="let row of item.RowDetails">
      <p-panel class="p-panel" [collapsed]="false" [toggleable]="true">
          <ng-template pTemplate="header">
            <div>
              <a class="name">
                <div>我是標題</div>
              </a>
            </div>
          </ng-template>

          <ng-template pTemplate="headericons">
            <img class="black-arrow" src="/assets/images/black-arrow.svg" />
          </ng-template>

          <ng-container *ngFor="let col of item.Columns; let i = index">
            <div class="panel-item">
              <div class="name">
                 {{ col.ColumnsName }}
              </div>
              <div class="desc">
                 {{ row[i] }}
              </div>
            </div>
          </ng-container>
      </p-panel>
    </ng-container>
 </ng-container> -->
<!--   <ng-container *ngFor="let item of data.Tables">
    <table class="table-mob">
      <thead>
        <tr>
          <th>期貨代號
            <span class="code">item.Future_Code</span>
          </th>
          <th class="name">
            item.Future_Name
          </th>
          <th>口數
            <span>item.Future_Unit</span>
          </th>
          <th>投資比例
            <span>item.Future_Percentage</span>
          </th>
          <th>契約年月
            <span>item.Future_Y_M</span>
          </th>
        </tr>
      </thead>
    </table>
  </ng-container> -->
  <!-- 動態表格 end -->
</main>
